<template>
  <div class="summary-holder" v-if="orderSummaryData.order_hash || globalPaymentForm">
    <h1>{{ t.summary }}</h1>

    <p v-html="t.summary_top">
    </p>

    <div class="row">
      <div class="col-md-6">
        <h2>{{ t.invoice_details }}</h2>
        <p>{{ orderSummaryData.invoice_address }}</p>
      </div>

      <div class="col-md-6" v-if="orderSummaryData.shipping_address">
        <h2>{{ t.shipping_details }}</h2>
        <p>{{ orderSummaryData.shipping_address }}</p>
      </div>
    </div>

    <div class="row" v-if="productData.products_count">
      <div class="col-md-12">
        <h2>{{ t.products }}</h2>

        <div class="webshop-cart-desktop table-responsive">
          <table class="table">
            <tbody>

              <tr class="table-top">
                <td colspan="5"></td>
                <td class="text-center product-header-h1 border-left" v-if="productData.products_has_discount"><b>{{ t.discount }}</b></td>
                <td class="text-center product-header-h1 border-left" colspan="3"><b>{{ t.altogether }}</b></td>
              </tr>

              <tr class="table-header">
                <th>&nbsp;</th>
                <th class="product-header-h2">{{ t.name }}</th>
                <th class="product-header-h2 text-right">{{ t.cut_sizes }}</th>
                <th class="product-header-h2 text-right">{{ t.quantity }}</th>
                <th class="product-header-h2 text-right">{{ t.unit_price }}</th>
                <th class="product-header-h2 text-right border-left" v-show="productData.products_has_discount">{{ t.unit_price }}</th>
                <th class="product-header-h2 text-right border-left">{{ t.net }}</th>
                <th class="product-header-h2 text-right">{{ t.vat }}</th>
                <th class="product-header-h2 text-right">{{ t.gross }}</th>
              </tr>

              <tr v-for="(p, pidx) in productData.products" v-bind:key="pidx">
                <td v-html="p.product_image" class="product-image"></td>
                <td v-html="p.name_url" class="product-url">{{ p.name_url }}</td>

                <td class="text-right product-size">{{ getSizeWithRemaind(p) }}</td>

                <td class="text-right product-unit_size">
                  <span v-if="p.size=='-'">{{ p.quantity }} {{ t.db }}</span>
                  <span v-if="p.size=='-' && p.unit != t.db">, </span>
                  <span v-if="p.unit != t.db">{{ p.unit_size }}</span>
                  <span v-if="p.size!='-'">-</span>
                </td>
                <td class="text-right product-net-unit">{{ formatNumber(p.net_unit_price) }}</td>
                <td class="text-right product-net-unit-discount border-left" v-show="productData.products_has_discount"><span v-if="p.has_discount">{{ formatNumber(p.net_unit_discount_price) }}</span></td>
                <td class="text-right product-net border-left">{{ formatNumber(p.net_price) }}</td>
                <td class="text-right product-tax">{{ formatNumber(p.tax_value) }}</td>
                <td class="text-right product-total">{{ formatNumber(p.gross_price) }}</td>
              </tr>

            </tbody>
          </table>
        </div>

        <div class="webshop-cart-mobile">
          <div class="cart-item-data" v-for="(p, pidx) in productData.products" v-bind:key="pidx">

            <div class="row">
              <div class="col-12 product-url-mobile">
                <div class="product-image" v-html="p.product_image_raw"></div>
                <div class="product-name">{{ p.name }}</div>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.cut_sizes }}
              </div>
              <div class="col-6 text-left product-size-mobile">
                {{ p.size }}
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.quantity }}
              </div>
              <div class="col-6 text-left product-unit_size-mobile">
                {{ p.unit_size }}
              </div>
            </div>

            <div class="row product-item-line">
              <div class="col-6 text-left product-header-mobile">
                {{ t.unit_price }}
              </div>
              <div class="col-6 text-left product-net-unit-mobile">
                {{ formatNumber(p.net_unit_price) }}
              </div>
            </div>

            <div class="row" v-show="productData.products_has_discount">
              <div class="col-6 text-left product-header-mobile">
                {{ t.unit_price }}
              </div>
              <div class="col-6 text-left product-net-unit-discount-mobile">
                <span v-if="p.has_discount">{{ formatNumber(p.net_unit_discount_price) }}</span>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.net }}
              </div>
              <div class="col-6 text-left product-net-mobile">
                {{ formatNumber(p.net_price) }}
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.vat }}
              </div>
              <div class="col-6 text-left product-tax-mobile">
                {{ formatNumber(p.tax_value) }}
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.gross }}
              </div>
              <div class="col-6 text-left product-total-mobile">
                {{ formatNumber(p.gross_price) }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-12">
        <h2>{{ t.shipping_and_payment }}</h2>

        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <tbody>
              <tr>
                <th class="width100">&nbsp;</th>
                <th class="text-center">{{ t.net }}</th>
                <th class="text-center">{{ t.vat }}</th>
                <th class="text-center">{{ t.gross }}</th>
              </tr>

              <tr v-if="!orderSummaryData.shipping_country_id || orderSummaryData.shipping_country_id == 1 || orderSummaryData.shipping_country_id == 4">
                <td class="width100">{{ orderSummaryData.shipping_type }}, {{ orderSummaryData.payment_type }}</td>
                <td class="text-right order-shipping-total">{{ orderSummaryData.shipping_total_net }}</td>
                <td class="text-right order-shipping-total">{{ orderSummaryData.shipping_total_tax }}</td>
                <td class="text-right order-shipping-total">{{ orderSummaryData.shipping_total_gross }}</td>
              </tr>

              <tr v-if="orderSummaryData.shipping_country_id && orderSummaryData.shipping_country_id != 1 && orderSummaryData.shipping_country_id != 4">
                <td class="width100">{{ orderSummaryData.shipping_type }}, {{ orderSummaryData.payment_type }}</td>
                <td class="text-right order-shipping-total" colspan="3">{{ t.shipping_message }}</td>
              </tr>

              <tr>
                <td class="width100 text-right order-total">{{ t.total_amount }}:</td>
                <td class="text-right order-total">{{ orderSummaryData.total_net_price }}</td>
                <td class="text-right order-total">{{ orderSummaryData.total_tax }}</td>
                <td class="text-right order-total">{{ orderSummaryData.total_price }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-12">

        <label for="comment">{{ t.comment }}</label>
        <textarea class="form-control" rows="4" id="comment" v-model="formData.comment"></textarea>

        <p v-html="t.summary_bottom"></p>

      </div>

    </div>

    <div class="webshop-step-holder">

      <div class="webshop-step-left">
        <div class="step-button">
          <router-link :to="{ name: 'Shipping' }" class="btn btn-black-small text-red">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.back }}
          </router-link>
        </div>
      </div>

      <div class="webshop-step-right">
        <div class="step-button" v-if="orderSummaryData.is_credit_card">
          <button class="btn btn-primary-small" v-on:click="saveOrder">{{ t.pay }} <i class="fa fa-credit-card-alt" aria-hidden="true"></i></button>
        </div>

        <div class="step-button" v-if="!orderSummaryData.is_credit_card">
          <button class="btn btn-primary-small" v-on:click="saveOrder">{{ t.send_order }} <i class="fa fa-cart-arrow-down" aria-hidden="true"></i></button>
        </div>
      </div>

    </div>

    <div class="global-payment-form-holder" v-if="globalPaymentForm" v-html="globalPaymentForm"></div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Summary',
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      error: "getErrorData",
      userData: "getUserData",
      productData: "getProductData",
      settingData: "getSettingData",
      formData: "getFormData",
      orderSummaryData: "getOrderSummaryData",
      currentStep: "getCurrentStep",
      currentData: "getCurrentData",
      orderData: "getOrderData",
    }),
  },
  data() {
    return {
      globalPaymentForm: null
    }
  },
  methods: {
    getSizeWithRemaind: function (product){
      return product.size + (product.remainder_required?' '+this.t.with_remainder:'');
    },
    saveOrder: function (){
      let $this = this;

      let formData = {
        'page'    : 'Summary',
        'method'  : 'SaveOrder',
        'formData': $this.formData
      };

      $this.$store.dispatch('setData', formData);
    },
    // Segéd függvény | Van többi oldalon is
    formatNumber: function (number){
      let formatter = new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: this.orderData.currencyCode,
        minimumFractionDigits: 0
      });

      return formatter.format(number);
    },
  },
  created() {
    this.$store.commit("setCurrentStep", 'Summary');
  },
  updated() {
    // Ha "saveOrder" lefutott és súlyos hiba volt, akkor Cart oldalra dobom reload-olva...
    if(this.currentStep === 'Cart'){
      window.location.href = '/webshop/step/cart'
    }

    // Ha Global Payment volt
    if(this.currentStep === 'GlobalPayment'){
      this.globalPaymentForm = this.currentData.formData;
      document.getElementById("global-payment-form").submit();
    }

    // Köszönő oldalra dobom, ha mentés sikeres
    if(this.currentStep && this.currentStep !== 'Summary' && this.currentStep !== 'GlobalPayment'){
      window.location.href = this.currentStep;
    }
  }
}
</script>